import type { BettingRouteParams } from "@/features/betting/hooks/useBettingFilters";

/**
 * Falls back to Next To Go so a user without Live gets a list, not an empty
 * page. The URL guard tidies the address behind us.
 */
export const resolveTab = (
  tab: BettingRouteParams["tab"],
  canUseLive: boolean,
): BettingRouteParams["tab"] => (tab === "live" && !canUseLive ? "next" : tab);

/** Betting tab link, for menus and other callers outside the betting routes. */
export const bettingTabSearch = (tab: BettingRouteParams["tab"]) =>
  `?${new URLSearchParams({ page: "1", tab }).toString()}`;

/** Whether a URL points at the Live tab, for callers without route params. */
export const isLiveTabSearch = (search: string) =>
  new URLSearchParams(search).get("tab") === "live";

export type SportEventTotals = {
  totalOutrights: number;
  totalMatches: number;
  totalLive: number;
};

/** Drops sport filters that would leave the list empty on the new tab - a
 * live-only sport shouldn't survive a switch to Next To Go, or vice versa. */
export const hasEventsOnTab = (
  tab: BettingRouteParams["tab"],
  { totalOutrights, totalMatches, totalLive }: SportEventTotals,
) => {
  if (tab === "futures") return totalOutrights > 0;
  if (tab === "live") return totalLive > 0;
  return totalMatches > 0;
};
